import feedback_nb from "../nb/feedback";

const feedback: typeof feedback_nb = {
  header: "How was your experience filling out this form?",
  input: {
    beskrivelse: {
      label: "Please elaborate (optional)",
      helpText:
        "Do not write personal information such as name, national identity number or contact details, but feel free to use concrete examples of challenges you have experienced",
    },
  },
  button: {
    send: "Send feedback",
  },
  validering: {
    maxLength: "The description can not be longer than 250 characters",
  },
  emoji: {
    "1": "Poor",
    "2": "Not good",
    "3": "OK",
    "4": "Good",
    "5": "Fantastic!",
  },
  alert: {
    success: {
      header: "Thank you for the feedback",
      message: "Your input helps us make the service better!",
    },
    failure: {
      header: "Something went wrong",
      message:
        "Unfortunately, we have not received your feedback. Please try submitting again and thank you for taking the time to respond!",
    },
  },
};
export default feedback;
